export const account_settings_section = {
  profile_title: "Personal Information",
  email_title: "Change Your Email",
  password_title: "Change Your Password",
  mfa_title: "Two-Factor Authentication",
  back_to_account_aria: "Back to account",
} as const;
